<template>
  <div class="gmdj">
    <div class="content">
      <van-form ref="form">
        <div class="dg">
          <p class="title">购墓预约信息</p>
          <van-cell title="预约日期" required :value="formData.predate" @click="show = true" />
          <i class="van-icon van-icon-arrow van-cell__right-icon jiantou"></i>
          <van-calendar v-model="show" @confirm="onConfirm" />
          <van-cell-group>
            <van-field
              v-model="formData.userName"
              label="预约人姓名"
              placeholder="请输入预约人姓名"
              required
              type="text"
              :rules="xingmingRules"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              v-model="formData.mobile"
              label="预约人手机号"
              type="tel"
              placeholder="请输入预约人手机号"
              required
              :rules="telRules"
            />
          </van-cell-group>
        </div>
        <!---->
        <!---->
        <div class="line"></div>
        <div class="dg">
          <p class="title">备注</p>
          <van-field
            v-model="formData.userMemo"
            rows="1"
            autosize
            label=""
            type="textarea"
            placeholder="此为购墓预约，如需来园祭扫，请移步祭扫预约菜单进行预约。"
          />
        </div>
      </van-form>
    </div>
    <div class="clearBox"></div>
    <div class="footDiv">
      <div class="btn" style="width: 100%;" @click="submitTomb(1)">提交预约</div>
    </div>
    <!-- <div data-v-a9eb2a58 class>
      <div data-v-a9eb2a58 class="success">
        <p data-v-a9eb2a58 class="title">预约提交成功</p>
        <span data-v-a9eb2a58 class="text">
          您已成功提交预约
          <br />请在我的订单中查看预约反馈
        </span>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'goumudengji',
  data() {
    return {
      formData: {
        // mobile: '',

        // xingming: '',

        // date: '',
        // ms: '',
        myId: this.$store.getters.userId,
        predate: '',
        mobile: '',
        userName: '',
        userMemo: '',
      },
      saveFlag: false,
      show: false,

      // 校验手机号码
      telRules: [
        {
          required: true,

          trigger: 'onBlur',
        },
        {
          // 自定义校验规则
          validator: value => {
            return /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/.test(
              value
            )
          },

          trigger: 'onBlur',
        },
      ],

      xingmingRules: [
        {
          required: true,

          trigger: 'onBlur',
        },
      ],
    }
  },
  computed: {},
  created() {},
  methods: {
    submitTomb() {
      var that = this
      if (that.formData.predate == '') {
        that.$toast.fail('请选择预约日期~')
        return
      }
      if (that.formData.userName == '') {
        that.$toast.fail('请填写预约人姓名~')
        return
      }
      if (that.formData.mobile == '') {
        that.$toast.fail('请填写预约人手机号~')
        return
      }
      this.$submit('/api/msgtomb/addTomb', this.formData, function(res) {
        if (res['code'] === 1) {
          that.$toast.success('提交成功！')
        }
      })
    },
    formatDate(predate) {
      console.log(predate)
      return `${predate.getFullYear()}-${predate.getMonth() + 1}-${predate.getDate()}`
    },
    onConfirm(predate) {
      this.show = false
      this.formData.predate = this.formatDate(predate)
    },
  },
  watch: {
    formData: {
      handler() {
        if (
          /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/.test(
            this.formData.mobile
          ) &&
          this.formData.userName &&
          this.formData.predate
        ) {
          this.saveFlag = true
        } else {
          this.saveFlag = false
        }
      },
      deep: true,
    },
  },
}
</script>
<style>
/* .success {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    visibility: hidden;
    opacity: 0;
    transition: all 1s ease;
    border: 1px solid #eee;
    width: 22rem;
    padding: 3rem 1rem;
    font-size: 1.4rem;
    border-radius: .5rem;
    text-align: center;
    background: #fff;
    box-shadow: 1px 2px 5px rgb(0 0 0 / 20%);
}
.success .title {
    color: #15a892;
}
.success .text {
    color: #999;
    line-height: 2.4rem;
    margin-top: 2.4rem;
    display: block;
} */
.gmdj .van-field__control {
  text-align: right;
}
.gmdj .jiantou {
  position: absolute;
  right: 2rem;
  top: 6.5rem;
}
.gmdj .content {
  padding: 1rem;
  font-size: 1.6rem;
}
.gmdj .dg {
  padding: 0 1.5rem 0.2rem;
  background-color: #fff;
}
.gmdj .dg .title {
  padding: 1.3rem 0;
  line-height: 2rem;
}
.gmdj .line {
  width: 100%;
  height: 1rem;
}

.gmdj .line {
  width: 100%;
  border-bottom: 1px solid #eee;
}
.gmdj .clearBox {
  clear: both;
  height: 5rem;
}
.gmdj .footDiv {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 5rem;
  line-height: 5rem;
  font-size: 1.6rem;
  background-color: #fff;
  display: flex;
  justify-content: flex-end;
}
.gmdj .footDiv .btn {
  width: 13.5rem;
  font-size: 1.4rem;
  text-align: center;
  background-color: #15a892;
  color: #fff;
  width: 100%;
}
</style>
